// ...existing code...

/**
 * 初始化微信分享卡片
 * @param {Object} options - 分享内容配置
 * @param {string} options.title - 分享标题
 * @param {string} options.desc - 分享描述
 * @param {string} options.link - 分享链接
 * @param {string} options.imgUrl - 分享图片
 */
export function wxShare({ title, desc, link, imgUrl }) {
  // 获取当前页面URL（去掉hash）
  const url = window.location.href.split('#')[0];

  // 获取签名
  fetch(`https://prodapi.gzsle.com/wechatGateway/getJsapiSignature?url=${encodeURIComponent(url)}`)
    .then(res => res.json())
    .then(wxResponse => {
      if (!window.wx) {
        console.error('微信JS-SDK未加载');
        return;
      }
      window.wx.config({
        appId: 'wx4022125406bcbd12',
        timestamp: wxResponse.timestamp,
        nonceStr: wxResponse.nonceStr,
        signature: wxResponse.signature,
        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
      });

      window.wx.ready(function () {
        // 分享给朋友
        window.wx.updateAppMessageShareData({
          title,
          desc,
          link,
          imgUrl
        });

        // 分享到朋友圈
        window.wx.updateTimelineShareData({
          title,
          link,
          imgUrl
        });
      });

      window.wx.error(function (err) {
        console.error('微信JS-SDK配置失败:', err);
      });
    })
    .catch(err => {
      console.error('获取微信签名失败:', err);
    });
}

